/* eslint-disable @typescript-eslint/no-explicit-any */
import { faPlus, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Modal } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useSelector, useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import legalEntityService from 'service/legalEntity';
import { showAlert } from 'store/alert/alert.thunk';
import movingService from 'service/movement';
import NewMovementsDataTable from './NewMovementsDataTable';

const CreateNewMovements = () => {
  const { t } = useTranslation();
  const { control, getValues } = useForm();
  const dispatch: Dispatch<any> = useDispatch();
  const cashboxId = useSelector((state: any) => state?.shiftId?.shiftId);
  const cashboxPid = useSelector((state: any) => state?.shiftId?.shiftPid);
  const navigate = useNavigate();

  const [legalEntityOption, setLegalEntityOption] = useState<any>([]);
  const [openFolder, setOpenFolder] = useState(false);
  const [loading, setLoading] = useState(false);

  //GET LEgal Entity to options
  useQuery(['GET_LEGAL_ENTITY'], async () => {
    await legalEntityService
      .getLegalEntityGraph({ offset: 0, limit: 100, under_control: true })
      .then((res: any) => {
        const options = res?.legal_entities.map((option: any) => ({
          value: option.id,
          pid: option?.pid || 0,
          currency_id: option?.currency_id || '',
          currency_pid: option?.currency_pid || 0,
          label: option.name
        }));

        setLegalEntityOption(options);
      });
  });

  const handleSave = () => {
    const data = getValues();

    if (!cashboxId) {
      dispatch(showAlert({ title: t('shift_not_open') }));
    }

    const selectedRecipent = legalEntityOption.find(
      (item: any) => item?.value === data?.sender
    );
    if (data?.sender !== '' && cashboxId) {
      setLoading(true);
      movingService
        .createMoving({
          recipient_id: data?.sender,
          recipient_pid: selectedRecipent?.pid || 0,
          cashbox_id: cashboxId,
          cashbox_pid: cashboxPid || 0,
          currency_id: selectedRecipent?.currency_id,
          currency_pid: selectedRecipent?.currency_pid
        })
        .then((res: any) => {
          if (res) {
            setLoading(false);
            dispatch(
              showAlert({
                title: `${t('movements')} ${t('successfully_added')}`,
                type: 'success'
              })
            );
            navigate(
              `/movements/outgoing/filter/newmovements/${res?.id}?sender_id=${res?.recipient_id}`,
              {
                state: {
                  newMovingPid: res?.pid
                }
              }
            );
          }
        });
    }
  };

  return (
    <Form
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Form.Group className="md-4">
        <div className="react-select-container">
          <Controller
            name="sender"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <Form.Floating>
                <Form.Select {...field}>
                  <option className="d-none" value=""></option>
                  {legalEntityOption?.map((option: any) => (
                    <option
                      key={option.value}
                      value={option.value}
                      className="option"
                    >
                      {option.label}
                    </option>
                  ))}
                </Form.Select>

                <label htmlFor="floatingInputCustom">{t('recipient')}</label>
              </Form.Floating>
            )}
          />
        </div>
      </Form.Group>
      <Form.Group style={{ display: 'flex', gap: '10px', marginTop: 'auto' }}>
        <Button
          variant="outline-primary"
          type="button"
          style={{ height: '48px', width: '100%' }}
          onClick={() => setOpenFolder(true)}
        >
          <FontAwesomeIcon icon={faFolderOpen} className="me-2" />
          {t('open')}
        </Button>
        <Button
          variant="primary"
          type="button"
          style={{ height: '48px', width: '100%' }}
          onClick={() => handleSave()}
          loading={loading}
          loadingPosition="start"
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          {t('create')}
        </Button>
      </Form.Group>

      <Modal
        show={openFolder}
        onHide={() => setOpenFolder(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t('select_moves')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewMovementsDataTable setOpenFolder={setOpenFolder} />
        </Modal.Body>
      </Modal>
    </Form>
  );
};

export default CreateNewMovements;
